import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import NavigationBar from '../../ReusableComp/NavigationBar';
import { PIFlowLeftNavBar } from '../../ReusableComp/NavBarLeft';
import { Card, Col, Container, Row, Stack, Table } from 'react-bootstrap';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, BarChart, Bar, Label, ReferenceArea} from "recharts";
import { useDispatch, useSelector } from 'react-redux';
import { getEventFlag, getPiStudies, getSubjectCounts } from '../../../Redux/actions/actions';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router';
import ToggleButton from 'react-toggle-button';
import { PIEventCards } from './PISubjectsList';

const PIDashboard = () => {
  const navigate = useNavigate();
  const dispatch= useDispatch();
  const subjectCounts = useSelector((state) => state.subjectCounts);
  const piDashboardChartData = useSelector((state) => state.piDashboardChartData);

  const listItems = useSelector((state) => state.studyInfo);
  const [toggleSAE, setToggleSAE] = useState(false);

  const [subjectRegistered, setSubjectRegistered] = useState({});
  const [adverseEvents, setAdverseEvents] = useState({});
  const [seriousAdverseEvents, setSeriousAdverseEvents] = useState({});
  const [minVal, setMinVal] = useState(0);
  const [maxVal, setMaxVal] = useState(0);
  const [midVal, setMidVal] = useState(0);


    
  useEffect(() => {
    if(!localStorage.getItem("login_user_name")){
        navigate("/");
    }
    disableBackButton();
     if(piDashboardChartData !== null && piDashboardChartData !== undefined && piDashboardChartData?.length !=0){
      const newData = Object.keys(piDashboardChartData?.aesCount)?.map((date) => ({
        name: getDayAbbreviation(date),
        "Last 7 days reported Adverse Events": piDashboardChartData?.aesCount[date],
      }));
      setAdverseEvents(newData);
      const newData1 = Object.keys(piDashboardChartData?.saesCount).map((date) => ({
        name: getDayAbbreviation(date),
        "Last 7 days reported Serious Adverse Events": piDashboardChartData?.saesCount[date],
      }));
      setSeriousAdverseEvents(newData1);

      const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ];
      
      // Convert the data to the desired format
      const result = Object.entries(piDashboardChartData?.subjectsEnrolled).map(([key, value]) => {
        const [month, year] = key.split("-");
        const monthIndex = parseInt(month) - 1;
        const name = months[monthIndex] + "-" + year.slice(-2);
      
        return {
          name,
          "Month Wise Subjects Registered": value,
          amt: value // You can set the "amt" value accordingly if needed
        };
      });

      setSubjectRegistered(result)
      const yValues = result?.map(item => item["Month Wise Subjects Registered"]);
      setMinVal(0);
      setMaxVal(Math.max(...yValues));
      setMidVal((0 + maxVal) / 2)
    }
    
  }, [piDashboardChartData]);

  
    
    function getDayAbbreviation(dateString) {
      const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const date = new Date(dateString);
      const dayIndex = date.getDay();
      return days[dayIndex];
    }


    function disableBackButton() {
      window.history.pushState(null, null, window.location.pathname);
      window.addEventListener('popstate', function(event) {
        window.history.pushState(null, null, window.location.pathname);
      });
    }
  useEffect(() => {
    dispatch(getPiStudies(localStorage.pi_id))
  }, [dispatch, localStorage.pi_id])

  const handleNavigate =(card, index)=>{
     
    navigate(card.url);
    let option
    if(card.desc ==="Serious Adverse Events"){
      option = "serious_adverse_events"
    }else if(card.desc==="Adverse Events"){
      option = "adverse_events"
    }else if(card.desc==="Total Subjects"){
      option = "all_events"
    }
    card.option = option 

    dispatch(getEventFlag(card))
     
  }

    const dashboardCards = [
        {
            count: subjectCounts?.seriousAdverseEventsCount,
            image: './images/icons/exclamatory.svg',
            desc: 'Serious Adverse Events',
            bgcolor: '#D14141',
            url: "/pisubjectslist"
        },
        {
            count: subjectCounts?.adverseEventsCount,
            image: './images/icons/smiley.svg',
            desc: 'Adverse Events',
            bgcolor: '#EA9E4F',
            url: "/pisubjectslist"
        },
        {
            count: subjectCounts?.subjectsCount,
            image: './images/icons/subjects_white.svg',
            desc: 'Total Subjects',
            bgcolor: '#8DA2B5',
            url: "/pisubjectslist"
        },
    ]

    const getPath = (x, y, width, height) => {
      const borderRadius = 10; 
      const barWidth = width / 1; 
      const halfWidth = barWidth / 0.66;
      
      return `M${x + halfWidth},${y + height - borderRadius}
        L${x + halfWidth},${y + borderRadius}
        Q${x + halfWidth},${y},${x + halfWidth + borderRadius},${y}
        L${x + halfWidth + barWidth - borderRadius},${y}
        Q${x + halfWidth + barWidth},${y},${x + halfWidth + barWidth},${y + borderRadius}
        L${x + halfWidth + barWidth},${y + height - borderRadius}
        Q${x + halfWidth + barWidth},${y + height},${x + halfWidth + barWidth - borderRadius},${y + height}
        L${x + halfWidth + borderRadius},${y + height}
        Q${x + halfWidth},${y + height},${x + halfWidth},${y + height - borderRadius}
        Z`;
    };
    
    const RoundedBar = (props) => {
      const { fill, x, y, width, height } = props;
      const barWidth = width / 4; // Set the width to one-fourth of the available width
    
      return <path d={getPath(x, y, barWidth, height)} stroke="none" fill={fill} />;
    };
    const handleStudyChange = () => {
      
    }

  const generateString = (n) => {
    const array = [];
    for (let i = 1; i <= n; i++) {
      array.push(`D${i}`);
    }
    return array.join(',');
  };
    
const onMouseEnter = ()=>{
  
}
    return (
        <div>
            <NavigationBar title={'Dashboard'} handleFilteredData={handleStudyChange}/>
            {/* <PIFlowLeftNavBar /> */}
            <div className='main_body '>
                
            <Container fluid className='py-3 py-lg-4 mb-5 pb-5 mb-md-0 pb-md-0'>
            <Stack>
              {listItems &&
              <ul className='pidblistitems'>
                <li>Study Name: {listItems.study_name}</li>
                <li>Doses: {generateString(listItems.number_of_doses)}</li>
                <li>Duration Between Doses: {listItems.duration_between_doses} {listItems.duration_between_doses_type}</li>
                <li>Age Group: {listItems.age_group}</li>
                
                {/* <li>Study Duration: <span className='styl'>{moment(i.study_duration_from).format("DD-MMM-YYYY")} to {moment(i.study_duration_from).format("DD-MMM-YYYY")}</span></li> */}
              </ul>
            }

            </Stack>
                    <Container fluid className="p-0">
                    <Row className="d-flex pb-2 p-0">
                      {dashboardCards?.map((card, index) => {
                          return (
                              <Col key={index} xs={6} md={4} className={`pb-md-0 pe-0 p-0 ${index ===0 ||index===2?"pe-2 pb-2" : index===1 ? 'pb-2 pe-md-2':''}`}>
                                  <div className='card-container C-pointer' onClick={() => handleNavigate(card, index)} style={{ backgroundColor: card.bgcolor }}>
                                      <div className='content'>
                                          <span>{card.count}</span>
                                          <img src={card.image} alt="" />
                                      </div>
                                      <div className='desc'>{card.desc}</div>
                                  </div>
                              </Col>
                          )
                      })}
                  </Row>
                    </Container>
                    <Container fluid className='p-0'>

                        <Row className='p-0'>
                            <Col xs={12} md={6} className='p-0 pe-md-3'>
                                <Card className='pidbcard'>
                                    <Card.Body className=''>
                                        <Card.Title className='mb-3 db_chart_title'>Subjects Registered</Card.Title>
                                        
                                      <LineChart
                                        width={window.screen.width >720 ?530 : 300}
                                        height={300}
                                        data={subjectRegistered}
                                        margin={{ top: 5, right: 5, bottom: 5, left: 5 }}
                                        className='responsive-chart'
                                      >
                                        <CartesianGrid strokeDasharray=" 0" />
                                        <XAxis dataKey="name" tick={{ fontSize: 14 }}/>
                                        <YAxis tick={{ fontSize: 14 }}>
                                          <Label dy={-35} value="Number of Subjects" offset={8} position="insideBottomLeft" angle={-90} fontSize={14} />
                                        </YAxis>
                                          {/* First half of the graph */}
                                          <ReferenceArea y1={minVal} y2={midVal} fill="#f9d57a" />

                                          {/* Second half of the graph */}
                                          <ReferenceArea y1={midVal} y2={maxVal} fill="#6f9adf" />
                                        <Tooltip />
                                        <Legend />
                                        <Line type="monotone" dataKey="Month Wise Subjects Registered" stroke="#eb9c09"  dot={null}/>
                                        
                                      </LineChart>


                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={12} md={6} className='p-0 pe-md-3'>
                                <Card className='pidbcard'>
                                    
                                    {!toggleSAE ? 
                                    <Card.Body>
                                        <Card.Title className='mb-3 db_chart_title' style={{display:"flex", justifyContent:"space-between"}}>
                                            Adverse Events Reported 
                                            <span style={{display:"flex"}}>
                                            <span>Serious:   </span>
                                            <span style={{marginLeft:"10px"}} className='asdfasdfsadf'>
                                            <ToggleButton value={toggleSAE}
                                            onToggle={() => {
                                                setToggleSAE(!toggleSAE);
                                            }}
                                            inactiveLabel={"No"}
                                            activeLabel={"Yes"}
                                            colors={{
                                                activeThumb: {
                                                    base: "rgb(250,250,250)",
                                                },
                                                active: {
                                                    base: "rgb(209, 65, 65)",
                                                },
                                                inactive: {
                                                    base: "rgb((0, 128, 0)",
                                                },
                                            }}
                                        />
                                        </span>
                                        </span>
                                        </Card.Title> 
                                        <BarChart width={window.screen.width >720 ?530 : 300} barGap={10} height={300} data={adverseEvents.length>0?adverseEvents.toReversed():adverseEvents} margin={{ top: 5, right: 5, bottom: 5, left: 5 }} className='responsive-chart'>
                                          <CartesianGrid strokeDasharray="0" />
                                          <XAxis dataKey="name" tick={{ fontSize: 14 }}/>
                                          <YAxis tick={{ fontSize: 14 }}>
                                            <Label dy={-35} value="# of Adverse Events" offset={10} position="insideBottomLeft" angle={-90} fontSize={14} />
                                          </YAxis>
                                          <Tooltip />
                                          <Legend/>
                                          <Bar dataKey="Last 7 days reported Adverse Events" fill="#EA9E4F" shape={<RoundedBar/>} onMouseEnter={onMouseEnter} />
                                        </BarChart>
                                        
                                        </Card.Body>
                                        : 
                                        <Card.Body>
                                        <Card.Title className='mb-3 db_chart_title' style={{display:"flex", justifyContent:"space-between"}}>
                                        Serious Adverse  Events  Reported 
                                        <span style={{display:"flex"}}>
                                        <span>Serious:   </span>
                                        <span style={{marginLeft:"10px"}}>
                                        <ToggleButton width={70} value={toggleSAE}
                                        onToggle={() => {
                                            setToggleSAE(!toggleSAE);
                                        }}
                                        inactiveLabel={"No"}
                                        activeLabel={"Yes"}
                                        colors={{
                                            activeThumb: {
                                                base: "rgb(250,250,250)",
                                            },
                                            active: {
                                                base: "rgb(209, 65, 65)",
                                            },
                                            inactive: {
                                                base: "rgb((0, 128, 0)",
                                            },
                                        }}
                                    />
                                    </span>
                                    </span>
                                    </Card.Title>
                                    <BarChart width={window.screen.width >720 ?530 : 300} barGap={10} height={300} data={seriousAdverseEvents.length>0?seriousAdverseEvents.toReversed():seriousAdverseEvents} margin={{ top: 5, right: 5, bottom: 5, left: 5 }} className='responsive-chart'>
                                    <CartesianGrid strokeDasharray="0" />
                                    <XAxis dataKey="name" tick={{ fontSize: 14 }}/>
                                    <YAxis tick={{ fontSize: 14 }}>
                                      <Label dy={-10} value="# of Serious Adverse Events " offset={10} position="insideBottomLeft" angle={-90} fontSize={14} />
                                    </YAxis>
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="Last 7 days reported Serious Adverse Events" fill="#EA9E4F" shape={<RoundedBar/>} onMouseEnter={onMouseEnter} />
                                  </BarChart>
                                  </Card.Body>
                                    }
                                            
                                    
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </Container>
            </div>

        </div>
    );
};

export default PIDashboard;


  
